module.exports = __webpack_public_path__ + "img/fuli_en_US_img2.54a09b2a.png";